import { render, staticRenderFns } from "./detail-item.vue?vue&type=template&id=5c3be45c&scoped=true"
import script from "./detail-item.vue?vue&type=script&setup=true&lang=js"
export * from "./detail-item.vue?vue&type=script&setup=true&lang=js"
import style0 from "./detail-item.vue?vue&type=style&index=0&id=5c3be45c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3be45c",
  null
  
)

export default component.exports